import * as React from "react"
const Fuel = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width={"100%"}
        height={"100%"}
        x={0}
        y={0}
        viewBox="55.533 9.776 24.96 42.141"
        {...props}
    >
        <style>
            {`.st0{fill:none;stroke:${props.color};stroke-width:.6;stroke-miterlimit:10}`}
        </style>
        <g id="Layer_4">
            <path
                d="M72.7 50.2c-3.3-1.3-6.8-1.5-10.6.1-3.3-7.5-4.7-16.2-5.3-25.8 0-5 4.1-9.1 8.9-9.4.9-.3 2.2-.2 3.5 0 5.3.3 9.4 4.4 9.4 9.4-.9 10.5-5.9 25.7-5.9 25.7z"
                className="st0"
            />
            <ellipse cx={67.6} cy={19.6} className="st0" rx={3.2} ry={2} />
            <ellipse cx={67.7} cy={19.7} className="st0" rx={4.3} ry={3} />
            <path
                d="M70.8 35.1c-2.2.5-4.4.5-6.6-.1-1.5-5.3-1.9-10.9-1.8-16.6 3.4-3.5 7.3-3.4 10.4 0-.2 5.7-.6 11.3-2 16.7z"
                className="st0"
            />
            <ellipse cx={67.7} cy={19.4} className="st0" rx={0.2} ry={0.1} />
        </g>
        <path
            d="M62.7 15.8c0-2.3-1.6-4.5-4.9-4.5M72.8 15.8c0-2 2.3-4.1 5.2-4.1"
            className="st0"
        />
    </svg>
)
export default Fuel
